module.exports = __webpack_public_path__ + "media/img/ms-icon-144x144-973ee86dfeda9b247e37c592179927e7.png";